"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

class NamedError extends Error {
  constructor({
    name,
    message,
    data,
    level,
    logger
  }) {
    var _logger$bindings;

    super(message);
    if (logger != null) this.context = (_logger$bindings = logger.bindings) === null || _logger$bindings === void 0 ? void 0 : _logger$bindings.call(logger);
    if (name != null) this.name = name;
    if (data != null) this.data = data;
    if (level != null) this.level = level;
    Error.captureStackTrace(this, NamedError);
  }

}

exports.default = NamedError;
//# sourceMappingURL=index.js.map